export default __webpack_public_path__ + "static/media/green-heart.2b31d1cb.png";